import { render, staticRenderFns } from "./TagTableCell.vue?vue&type=template&id=2c1d57d6&scoped=true"
import script from "./TagTableCell.vue?vue&type=script&lang=js"
export * from "./TagTableCell.vue?vue&type=script&lang=js"
import style0 from "./TagTableCell.vue?vue&type=style&index=0&id=2c1d57d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d57d6",
  null
  
)

export default component.exports